<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import { menuItems_0 } from "./menu";

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      userLogged: {},
      menuItems: [],
      menuData: null,
      menusTmsFree: [
        /*
        * Dashboard
        */
        // 'menuitems.dashboards.text',
        // 'menuitems.dashboards.list.fretes',
        // 'menuitems.dashboards.list.analitico',
        // 'menuitems.dashboards.list.supervisao',

        /*
        * Administrativo
        */
        // 'menuitems.administrativo.text',
        //'menuitems.administrativo.listusers.listarusers',
        // 'menuitems.cadastros.list.representantes',
        // 'menuitems.administrativo.listempresas.listarempresas',
        // 'menuitems.administrativo.listimpressoras.listarimpressoras',
        // 'menuitems.clientes.list.listar',

        /*
        * ERP
        */
        // 'menuitems.cadastros.text',
        // 'menuitems.cadastros.list.condicoes',
        // 'menuitems.cadastros.list.formas',

        /*
        * PRODUTOS
        */
        // 'menuitems.produtos.text',
        // 'menuitems.produtos.list.listar',
        // 'menuitems.produtos.list.tabelas',
        // 'menuitems.produtos.list.relatproduto',

        /*
        * FINANCEIRO
        */
        // 'menuitems.financeiro.text',
        // 'menuitems.financeiro.list.contacorrente',
        // 'menuitems.financeiro.list.fluxocaixa',
        // 'menuitems.financeiro.list.contaspagar',
        // 'menuitems.financeiro.list.contasreceber',
        // 'menuitems.financeiro.list.comissoes',
        // 'menuitems.financeiro.list.relatfinanc',

        /*
        * Fiscal
        */
        // 'menuitems.fiscal.text',
        // 'menuitems.fiscal.list.naturezas',
        // 'menuitems.fiscal.list.cfop',
        // 'menuitems.fiscal.list.relatfiscal',

        /*
        * Estoque
        */
        // 'menuitems.estoque.text',
        // 'menuitems.estoque.list.produtos',
        // 'menuitems.estoque.list.carregamento',
        // 'menuitems.estoque.list.inventario',
        // 'menuitems.estoque.list.transf',
        // 'menuitems.estoque.list.relatestoque',

        /*
        * OPERAÇÃO
        */
        // 'menuitems.wms.text',
        // 'menuitems.wms.list.wmsossaida',
        // 'menuitems.wms.list.wmsosentrada',
        // 'menuitems.wms.list.romaneio',
        // 'menuitems.wms.list.paletes',
        // 'menuitems.wms.list.relatwms',

        /*
        * COLETOR
        */
        // 'menuitems.coletor.text',
        // 'menuitems.coletor.list.conferenciacoletor',
        // 'menuitems.coletor.list.inventariocoletor',

        /*
        * TMS
        */
        'menuitems.tms.text',
        'menuitems.tms.list.tms_newdashboard',
        'menuitems.tms.list.dash_fretegeral',
        'menuitems.tms.list.dash_fretetransp',
        'menuitems.tms.list.dash_freteestado',
        'menuitems.tms.list.dash_freteregiao',

        // 'menuitems.tms.list.cotacoes',
        // 'menuitems.tms.list.cotacoesdedicadas',
        // 'menuitems.tms.list.tabelasfrete',

        // 'menuitems.controle.text',
        // 'menuitems.controle.list.consultacte',
        // 'menuitems.controle.list.consultanfe',
        // 'menuitems.controle.list.processamentofretes',
        // 'menuitems.controle.list.controleentregas',
        // 'menuitems.controle.list.relatoriofretes',
        // 'menuitems.controle.list.tabelasfrete',

        // 'menuitems.integracoes.text',
        // 'menuitems.integracoes.list.transportadoras',

        // 'menuitems.pedidos.text',
        // 'menuitems.pedidos.list.listar',
        // 'menuitems.pedidos.list.anymarketpeds',
        // 'menuitems.pedidos.list.blingpeds',
        // 'menuitems.pedidos.list.mercadolivre',
        // 'menuitems.pedidos.list.movshopeetrk',
        // 'menuitems.pedidos.list.traypeds',
        // 'menuitems.pedidos.list.vindipeds',

        //'menuitems.geral.text',
        //'menuitems.geral.list.transportadoras',

        'menuitems.configuracoes.text',
        'menuitems.configuracoes.listusers.listarusers',
        'menuitems.configuracoes.listusers.detalhesuser',
        'menuitems.configuracoes.listusers.editaruser',
        'menuitems.configuracoes.listempresas.listarempresas',
        'menuitems.configuracoes.listempresas.editarempresa',
        'menuitems.configuracoes.listimpressoras.listarimpressoras',
        'menuitems.configuracoes.list.meuperfil',
        'menuitems.configuracoes.list.cadastrosgerais',


        'menuitems.suporte.text',
        'menuitems.suporte.list.chamados',
        'menuitems.suporte.list.material',
        'menuitems.suporte.list.faleconosco',


        'menuitems.tms.list.tms_cotacoes',
        'menuitems.tms.list.cotacoes_frete',
        'menuitems.tms.list.cotacoes_dedicadas',
        'menuitems.tms.list.tabela_frete',
        'menuitems.tms.list.tabela_frete_elk',


        'menuitems.tms.list.tms_controle',
        'menuitems.tms.list.consulta_ctes',
        'menuitems.tms.list.consulta_nfes',
        'menuitems.tms.list.processamento_frete',
        'menuitems.tms.list.controle_entrega',
        'menuitems.tms.list.relatorios_frete',

        'menuitems.tms.list.integracoes',
        'menuitems.tms.list.integracao1',
        'menuitems.tms.list.integracao2',
        'menuitems.tms.list.integracao3',
        'menuitems.tms.list.integracao4',

      ],
      menusRetomada: [
        'menuitems.econocargo.text',
        'menuitems.dashboards.list.fretes',
        'menuitems.dashboards.list.transportadora',
        'menuitems.dashboards.list.transpestado',
        'menuitems.dashboards.list.transpregiao',
        'menuitems.econocargo.list.listarinterna',
        'menuitems.econocargo.list.listarexterna',
        'menuitems.econocargo.list.listar',
        'menuitems.econocargo.list.editar',
        'menuitems.econocargo.list.listardedicada',
        'menuitems.econocargo.list.editardedicada',
        'menuitems.transportador.list.cte',
        'menuitems.transportador.list.editarcte',
        'menuitems.transportador.list.importarcte',
        'menuitems.transportador.list.ctecotaassinc',
        'menuitems.orcamentos.list.listarmov',
        'menuitems.orcamentos.list.listarmovnv',
        'menuitems.orcamentos.list.cotarmov',
        'menuitems.orcamentos.list.editarmov',
        'menuitems.orcamentos.list.impmov',
        'menuitems.econocargo.list.tracking',
        'menuitems.econocargo.list.apurafretes',
        'menuitems.orcamentos.list.processamento',
        'menuitems.econocargo.list.controleentrega',
        'menuitems.econocargo.list.movagendamento',
        'menuitems.econocargo.list.trackermsgs',
        'menuitems.econocargo.list.instwhats',
        'menuitems.econocargo.list.relatfrete',

        'menuitems.clientes.text',
        'menuitems.clientes.list.listar',
        'menuitems.clientes.visitas',
        'menuitems.clientes.mapas',
        'menuitems.clientes.list.editar',
        'menuitems.clientes.list.detalhes',
        'menuitems.clientes.list.pesquisa',
        'menuitems.clientes.list.leads',
        'menuitems.clientes.list.comunicacao',
        'menuitems.clientes.list.editarmsg',
        'menuitems.clientes.list.relatcrm',

          'menuitems.wms.text',
          'menuitems.wms.list.wmsossaida',
          'menuitems.wms.list.wmsosentrada',
          'menuitems.wms.list.editarwmsos',
          'menuitems.wms.list.editarwmsosentr',
          'menuitems.wms.list.editarwmsos',
          'menuitems.wms.list.editarwmsosroma',
          'menuitems.wms.list.enderecamento',
          'menuitems.wms.list.romaneio',
          'menuitems.wms.list.editarwmsrom',
          'menuitems.wms.list.expedirwmsrom',
          'menuitems.wms.list.paletes',
          'menuitems.administrativo.listimpressoras.listarimpressoras',
          'menuitems.wms.list.relatwms',

          'menuitems.coletor.text',
          'menuitems.coletor.list.conferenciacoletor',
          'menuitems.coletor.list.inventariocoletor',
          'menuitems.coletor.list.transferenciacoletor',
          'menuitems.coletor.list.romaneiocoletor',

        'menuitems.suporte.text',
        'menuitems.suporte.list.chamados',
        'menuitems.suporte.list.material',
        'menuitems.suporte.list.faleconosco',

      ]

    };
  },
  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    let tipo = this.userLogged.tipo
    let novaMenuList = []

    console.log('montando_menu menus: ')
    console.log(tipo)
    if (this.userLogged.menus && this.userLogged.menus !== '') {
      console.log('this.userLogged.menu_customizado')
      console.log(this.userLogged.menus)
      const menusArr = this.userLogged.menus.split(',').map(String)
      // console.log('aaaa_menusArr')
      // console.log(menusArr)

      menusArr.forEach(itemUser => {
        console.log('aaaa_menu_item_usuario')
        console.log(itemUser)
        for (var contM = 0; contM < menuItems_0.length; contM++) {
            if (menuItems_0[contM]['subItems']) {
              menuItems_0[contM]['subItems'].forEach(itemSub => {
                  if (itemUser === itemSub['label']) {
                    console.log('itemSub')
                    console.log(itemSub)
                    let existePai = false
                    novaMenuList.forEach(itemNaLista => {
                      // console.log('novaMenuList')
                      // console.log(itemNaLista)
                      if (itemNaLista.id === itemSub['parentId']){
                        existePai = true
                      }
                    })
                    if (!existePai){
                      for (var contMF = 0; contMF < menuItems_0.length; contMF++) {
                        if (menuItems_0[contMF]['id'] === itemSub['parentId']) {
                          // console.log('pai identificado')
                          // console.log(menuItems_0[contMF])
                          let paiAadicionar = menuItems_0[contMF]
                          paiAadicionar['subItemsF'] = []
                          novaMenuList.push(paiAadicionar)
                        }
                      }
                    }
                    novaMenuList.forEach(itemNaLista => {
                      // console.log('itemNaLista')
                      // console.log(itemNaLista)
                      if (itemNaLista.id === itemSub['parentId']){
                        itemNaLista['subItemsF'].push(itemSub)
                      }
                    })
                  }
              })
            }
        }
      })
      novaMenuList.forEach(itemF => {
        console.log('itemF')
        console.log(itemF)
        itemF['subItems'] = itemF['subItemsF']
      })
      console.log('xxxx__novaMenuList')
      console.log(novaMenuList)

    } else {

      for (var cont = 0; cont <  menuItems_0.length; cont++) {
        if (tipo === 'cotacao'){
          if (menuItems_0[cont]['label'] === 'menuitems.econocargo.text') {
            novaMenuList.push(menuItems_0[cont])
          }
        } else if (tipo === 'logist') {
          if (menuItems_0[cont]['label'] === 'menuitems.econocargo.text' ||
              menuItems_0[cont]['label'] === 'menuitems.coletor.text') {
            novaMenuList.push(menuItems_0[cont])
          }
        } else if (tipo === 'coletor') {
          if (menuItems_0[cont]['label'] === 'menuitems.pedidos.text' ||
              menuItems_0[cont]['label'] === 'menuitems.wms.text' ||
              menuItems_0[cont]['label'] === 'menuitems.coletor.text') {
            novaMenuList.push(menuItems_0[cont])
          }
        } else if (tipo.includes('tms_')){
          console.log('tipo plano')
          // usuario plano
          if (this.menusTmsFree.includes(menuItems_0[cont]['label'])) {
            // console.log('menuItems_0[cont]')
            // console.log(menuItems_0[cont]['subItems'])

            let subItens = []
            if (menuItems_0[cont]['subItems']){
              for (var contSub = 0; contSub < menuItems_0[cont]['subItems'].length; contSub++) {
                if (this.menusTmsFree.includes(menuItems_0[cont]['subItems'][contSub]['label'])) {
                  if(menuItems_0[cont]['subItems'][contSub]['link'] && menuItems_0[cont]['subItems'][contSub]['link'].includes(':id')){
                    menuItems_0[cont]['subItems'][contSub]['link'] =
                        menuItems_0[cont]['subItems'][contSub]['link'].replace(':id', this.userLogged.id)
                  }
                  subItens.push(menuItems_0[cont]['subItems'][contSub])
                }
              }
            }
            menuItems_0[cont]['subItems'] = subItens
            novaMenuList.push(menuItems_0[cont])
          }

          novaMenuList.sort((a, b) => {
            return this.menusTmsFree.indexOf(a.label) - this.menusTmsFree.indexOf(b.label);
          });
        } else if (tipo.includes('retomada')){
          console.log('tipo plano retomada')
          // usuario plano
          if (this.menusRetomada.includes(menuItems_0[cont]['label'])) {
            // console.log('menuItems_0[cont]')
            // console.log(menuItems_0[cont]['subItems'])

            let subItens = []
            if (menuItems_0[cont]['subItems']){
              for (var contSubRet = 0; contSubRet < menuItems_0[cont]['subItems'].length; contSubRet++) {
                if (this.menusRetomada.includes(menuItems_0[cont]['subItems'][contSubRet]['label'])) {
                  if(menuItems_0[cont]['subItems'][contSubRet]['link'] && menuItems_0[cont]['subItems'][contSubRet]['link'].includes(':id')){
                    menuItems_0[cont]['subItems'][contSubRet]['link'] =
                        menuItems_0[cont]['subItems'][contSubRet]['link'].replace(':id', this.userLogged.id)
                  }
                  subItens.push(menuItems_0[cont]['subItems'][contSubRet])
                }
              }
            }
            menuItems_0[cont]['subItems'] = subItens
            novaMenuList.push(menuItems_0[cont])
          }

          novaMenuList.sort((a, b) => {
            return this.menusTmsFree.indexOf(a.label) - this.menusTmsFree.indexOf(b.label);
          });
        } else {

          // console.log('menuItems_0[cont]')
          // console.log(menuItems_0[cont]['exibir'])
          if (menuItems_0[cont]['exibir'] === true || menuItems_0[cont]['exibir'] === undefined) {
            const nivel = menuItems_0[cont]['nivel']
            if (nivel === 0){
              novaMenuList.push(menuItems_0[cont])
            }else if (nivel === 1){
              if (tipo === 'repres'){
                novaMenuList.push(menuItems_0[cont])
              }
            }else if (nivel === 100){
              if (tipo === 'admin'){
                novaMenuList.push(menuItems_0[cont])
              }
            }
          }
        }
      }
    }

    // console.log('novaMenuList')
    // console.log(novaMenuList)
    this.menuItems = novaMenuList
  },
  mounted: function () {
    // console.log('mounted_side-nav')
    // console.log(this.$route.path)
    // console.log(this.$route.path)
    if (document.getElementById("side-menu")) new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }
    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
          <a
              v-if="hasItems(item)"
              href="javascript:void(0);"
              class="is-parent"
              :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
                :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
                v-if="item.badge"
            >{{ $t(item.badge.text) }}</span
            >
          </a>

          <router-link
              :to="item.link"
              v-if="!hasItems(item)"
              class="side-nav-link-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
                :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
                v-if="item.badge"
            >{{ $t(item.badge.text) }}</span
            >
          </router-link>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <template v-if="subitem.exibir === true || this.$route.path.includes(subitem.link)">
                <router-link

                    :to="subitem.link"
                    v-if="!hasItems(subitem)"
                    class="side-nav-link-ref"


                >{{ $t(subitem.label) }}

                </router-link>
                <a
                    v-if="hasItems(subitem)"
                    class="side-nav-link-a-ref has-arrow"
                    href="javascript:void(0);"
                >{{ $t(subitem.label) }}</a
                >
                <ul
                    v-if="hasItems(subitem)"
                    class="sub-menu mm-collapse"
                    aria-expanded="false"
                >
                  <li
                      v-for="(subSubitem, index) of subitem.subItems"
                      :key="index"
                  >
                    <router-link
                        :to="subSubitem.link"
                        class="side-nav-link-ref"
                    >{{ $t(subSubitem.label) }}</router-link
                    >
                  </li>
                </ul>
              </template>
            </li>

          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>